export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-problem-1.455e7db5.png";